



































































































































import { Component, Vue } from 'vue-property-decorator';
import { IVehicle } from '@/models/Vehicle';
import { konsole } from '@/services/Konsole';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import Gallery from '@/components/Gallery.vue';
import VehicleOptions from '@/components/VehicleOptions.vue';
import VehicleDetails from '@/components/VehicleDetails.vue';
import { vehicleService } from '@/services/VehicleService';
import { ISettings } from '@/models/Settings';

@Component({
  components: { Gallery, VehicleOptions, VehicleDetails },
})
export default class Detail extends Vue {
  public item: IVehicle | null = { vehicle_id: '', license_plate: '' };
  public largeImages: string[] = [];
  public fullImages: string[] = [];
  public options: string[] = [];
  private isInitialLoading: boolean = true;
  private isError: boolean = false;
  private errorMessage: string = '';
  private description: string = '';
  private is_afleverpakketten: boolean = false;
  private settings: ISettings;

  constructor() {
    super();
    library.add(faArrowLeft);
    this.settings = this.$attrs.settings ? JSON.parse(this.$attrs.settings) as ISettings : {};
    // konsole.init('New instance of Detail');
  }

  // Created automatically fires when the class has been created
  private async created() {
    let response: any;

    try {
      // Get a single vehicle with param id from the API
      response = await vehicleService.getVehicle(this.$route.params.id);

      this.item = response.data as IVehicle;
      //console.log('vehicle', this.item);

      if (this.item.pictures) {
        for (const pic of this.item.pictures) {
          this.largeImages.push(pic.large);
          this.fullImages.push(pic.full);
        }
      }

      // description, TODO: check handelaar

      if (this.item.default_text && this.item.default_text.text_private) {
        for (let i = 0; i < this.item.default_text.text_private.length; i++) {
          const text = this.item.default_text.text_private;
          if (text[i].locale === 'nl-NL') {
            this.description = text[i].language_text;
          }
        }
      }

      // Afleverpakket
      if (this.item.delivery_package && this.item.delivery_package.length > 0) {
        for (let i = 0; i < this.item.delivery_package.length; i++) {
          const text = this.item.delivery_package[i];
          this.is_afleverpakketten = true;
        }
      }
    } catch (e) {
      console.error(e);
      this.isError = true;
      // TODO: better error message
      this.errorMessage = e.response.data.error;
    } finally {
      this.isInitialLoading = false;
      if (this.item && this.item['milometer_type']) {
        switch (this.item['milometer_type'].toLowerCase()) {
          case 'kilometers':
            this.item['milometer_type'] = 'km';
            break;
          case 'mijlen':
            this.item['milometer_type'] = 'mijl';
            break;
        }
      }
    }
  }

  private mounted() {
  // konsole.init('mounted');
    if(this.settings.forceScrollTop && this.settings.forceScrollTop.enforce === true){
      this.scrollToTargetAdjusted(this.settings.forceScrollTop.amount);
    } 
  }

  private scrollToTargetAdjusted(amount: number) {
    var element = document.getElementById('app');
    var headerOffset = amount ? amount : 0;
    var elementPosition = element ? element.getBoundingClientRect().top : 0;
    var offsetPosition = elementPosition - headerOffset;
    
    window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
    });   
  }


}
